import {SET_SESSIONS_DATA} from '../../Types/AllSessionData';

// Action creator to set sessions data
export const setSessionsData = (sessions) => ({
  type: SET_SESSIONS_DATA,
  payload: sessions,
});
